/**
 * Conditionally add elements inside Array literals.
 * @param condition
 * @param elements
 * @returns An array to be spread into an array literal.
 */
export function insertIf<T>(
  condition: boolean,
  ...elements: readonly T[]
): readonly T[] {
  return condition ? elements : []
}

export function equalsIgnoreOrder(
  a: readonly unknown[],
  b: readonly unknown[]
): boolean {
  const sortedA = [...a].sort()
  const sortedB = [...b].sort()

  return JSON.stringify(sortedA) === JSON.stringify(sortedB)
}
